import React, { Component } from "react";
import "./style.scss";
import classnames from "classnames";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { DocumentUploadViewTab } from "./DocumentUploadViewTab";
import { withTranslation } from "react-i18next";
import { DocumentUpload } from "component/Admin/Backend/Outlet master/DocumentUpload";
import { McForm } from "./McForm";

export class DocumentClass extends Component {
  state = {
    activeTab: "1",
    isOpenTreatmentDone: false,
    isActiveTab: "detail",
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  render() {
    let { t } = this.props;
    return (
      <div className="beautesoft-navlink customer-detail">
        <div className="filled-tabs">
          <div className="tabs-block">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggle("1");
                  }}
                >
                  {t("Document")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "2",
                  })}
                  onClick={() => {
                    this.toggle("2");
                  }}
                >
                  {t("MC Form")}
                </NavLink>
              </NavItem>
            </Nav>
          </div>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              {this.state.activeTab === "1" &&
                (this.props.backend ? (
                  <DocumentUpload id={this.props.id} />
                ) : (
                  <DocumentUploadViewTab id={this.props.id} />
                ))}
            </TabPane>
            <TabPane tabId="2">
              {this.state.activeTab === "2" && <McForm id={this.props.id} />}
            </TabPane>
          </TabContent>
        </div>
      </div>
    );
  }
}

export const Document = withTranslation()(DocumentClass);